import { render, staticRenderFns } from "./FreemiumSuppliers.vue?vue&type=template&id=3132c657&scoped=true&"
import script from "./FreemiumSuppliers.vue?vue&type=script&lang=js&"
export * from "./FreemiumSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./FreemiumSuppliers.vue?vue&type=style&index=0&id=3132c657&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132c657",
  null
  
)

export default component.exports